import { Button } from '@mui/material'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { MetaWrapper } from '../components/Meta'
import useGlobalLoader from '../hooks/useGlobalLoader'
import { Trans, useTranslation } from 'react-i18next'

const Page404 = () => {
  const { t } = useTranslation()
  const { setLoading } = useGlobalLoader()

  useEffect(() => {
    setLoading(false)
  }, [])

  return (
    <MetaWrapper>
      <div id='content'>
        <div className='not-found-page'>
          <h2 className='not-found-page__header'>404</h2>
          <div className='not-found-page__ruler' />
          <div className='not-found-page__message'>
            <Trans i18nKey='description.page404'>
              <p>We can’t seem to find a page you are looking for! </p>
              <p>You may have mistyped the address or the page may have moved. </p>
              <p>We’re sorry for the error and hope you’ll have a good day.</p>
            </Trans>
          </div>
          <div className='my-24'>
            <Button component={Link} to={'/'} variant='contained' size='large' style={{ width: 250 }}>
              {t('button.backToHome', 'Back to home')}
            </Button>
          </div>
        </div>
      </div>
    </MetaWrapper>
  )
}

export default Page404
